import { connect } from 'react-redux';
import CRUDAction from '../../../actions/event';
import EventsEditForm from '../EventsEditForm'
import LoadingContainer from '../../LoadingContainer';

export default connect(
  ({ event: { loadingItem } }) => ({
    loading: loadingItem,
    childrenComponent: EventsEditForm,
    childrenProps: {
      title: 'Edit Event',
      isNew: false
    }
  }),
  dispatch => ({
    init: ({ params: { id }}) => dispatch(CRUDAction.fetch(id))
  })
)(LoadingContainer);



// WEBPACK FOOTER //
// ./src/components/Events/EventsEdit/index.js